import React, { useEffect } from "react";
import { Box, Typography } from "@mui/material";
import { useDispatch, useSelector } from "../../../store";
import Breadcrumbs from "../../base/Breadcrumbs";
import { setSelectedDashboard } from "../../../slices/dashboard";
import Button from "../../base/Button";
import { ArrowBack, Edit } from "@mui/icons-material";
import { useNavigate } from "react-router-dom";
import { getBreadcrumbs, selectTile } from "../../../slices/tile";
import checkRole, { UserRoles } from "../../../helpers/checkRole";

interface Props {
  id: number;
}

const TileHeaderView: React.FC<Props> = (props) => {
  const { id } = props;

  const dispatch = useDispatch();
  const navigate = useNavigate();

  const { tile, breadcrumbs } = useSelector((store) => store.tiles);
  const { loggedInUser } = useSelector((store) => store.auth);

  useEffect(() => {
    dispatch(getBreadcrumbs(+id!));
  }, [dispatch, id]);

  const handleClick = () => {
    navigate(`/dashboard/${tile?.dashboard?.id}`);
  };

  const handleEditClick = () => {
    dispatch(selectTile(tile));
    dispatch(setSelectedDashboard(tile?.dashboard?.id));
    navigate(`/edit-tile/${tile?.id}`);
  };

  return (
    <Box display="flex" flexDirection="row" width="100%">
      <Box
        display="flex"
        flexDirection="column"
        justifyContent="center"
        alignItems="center"
        width="100%"
        marginX={3}
      >
        <Box
          display="flex"
          flexDirection="row"
          justifyContent="space-between"
          width="100%"
        >
          <Box display="flex" flexDirection="column">
            {breadcrumbs?.length! > 0 && (
              <Breadcrumbs breadcrumbs={breadcrumbs!} />
            )}
          </Box>
          <Box display="flex" flexDirection="column">
            <Box display="flex" flexDirection="row" gap={2}>
              <Button
                onClick={handleClick}
                label="Back"
                variant="contained"
                icon={<ArrowBack />}
                color="info"
              />
              {checkRole(loggedInUser!, UserRoles.AnyAdmin) && (
                <Button
                  onClick={handleEditClick}
                  label="Edit"
                  variant="contained"
                  icon={<Edit />}
                  color="secondary"
                />
              )}
            </Box>
          </Box>
        </Box>
        <Box display="flex" flexDirection="row" marginTop={3}>
          {!!tile && <Typography variant="h3">{tile.title}</Typography>}
        </Box>
      </Box>
    </Box>
  );
};

export default TileHeaderView;
